import { render } from "./EPermitCreate.vue?vue&type=template&id=4a422dc3"
import script from "./EPermitCreate.vue?vue&type=script&lang=js"
export * from "./EPermitCreate.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/tmulag_vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__